import { render, staticRenderFns } from "./NlpWhoIsFor.vue?vue&type=template&id=4df89083&scoped=true"
import script from "./NlpWhoIsFor.vue?vue&type=script&lang=js"
export * from "./NlpWhoIsFor.vue?vue&type=script&lang=js"
import style0 from "./NlpWhoIsFor.vue?vue&type=style&index=0&id=4df89083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df89083",
  null
  
)

export default component.exports